import { gql } from '@apollo/client';
// import { CORE_TOOL_CATALOG_FIELDS } from './tool-catalog';
import { CORE_USER_FIELDS } from './user';

export const CORE_TOOL_ORDER_FIELDS = gql`
  fragment ToolOrderCoreFields on ToolOrder {
    id
    orderNumber
    requiredStartDate
    status
    orderDate
    toolRoomId
    checkedOutByUser {
      bun
      firstName
      id
      upn
    }
    createdByUser {
      id
      firstName
      lastName
      employee {
        id
        imageUrl
      }
    }
    toolRoom {
      id
      barCode
      description
    }
    toolOrderCatalogs {
      id
      quantity
      similarToolCatalog {
        id
      }
      requesterComments
      toolOrderId
      toolCatalogId
      nonCatalogDescription
      nonCatalogReferenceUrl
      nonCatalogUomId
      toolCatalog {
        bscnPartNumber
        name
        id
        inventoryType
        toolCategoryId
        uomId
        isFavorite
        toolCatalogImageUrl
        uom {
          id
          abbreviation
        }
      }
    }
  }
`;
export const CREATE_TOOL_ORDER = gql`
  ${CORE_TOOL_ORDER_FIELDS}
  mutation CreateToolOrder($createToolOrderInput: CreateToolOrderInput!) {
    createToolOrder(createToolOrderInput: $createToolOrderInput) {
      toolOrder {
        ...ToolOrderCoreFields
      }
      error
    }
  }
`;

export const UPDATE_TOOL_ORDER = gql`
  ${CORE_TOOL_ORDER_FIELDS}
  mutation updateToolOrder($input: UpdateToolOrderInput!) {
    updateToolOrder(input: $input) {
      toolOrder {
        ...ToolOrderCoreFields
      }
      error
    }
  }
`;

export const MARK_PICK_UP_READY = gql`
  ${CORE_TOOL_ORDER_FIELDS}
  mutation markPickUpReady($id: ID!) {
    markPickUpReady(id: $id) {
      toolOrder {
        ...ToolOrderCoreFields
      }
    }
  }
`;

export const UPDATE_TOOL_ORDER_STATUS = gql`
  mutation UpdateToolOrderStatus($id: ID!, $status: ToolOrderStatus) {
    updateToolOrderStatus(id: $id, status: $status) {
      toolOrder {
        toolRoomId
        projectId
        orderNumber
        requiredStartDate
        status
        id
      }
      error
    }
  }
`;

export const GET_TOOL_ORDER_BY_USER_ID = gql`
  ${CORE_TOOL_ORDER_FIELDS}
  query ToolOrdersByUserId($toolOrdersByUserId: ID!) {
    toolOrdersByUserId(userId: $toolOrdersByUserId) {
      ...ToolOrderCoreFields
    }
  }
`;

export const SEARCH_TOOL_ORDER = gql`
  query SearchToolOrders($searchInput: SearchInput!) {
    searchToolOrders(searchInput: $searchInput) {
      items {
        id
        thTransactionNo
        orderNumber
        projectId
        status
        toolRoomId
        checkedOutDate
        orderDate
        requiredStartDate
        toolRoom {
          id
          description
          name
        }
        stats {
          consumablesCount
          id
          toolsCount
        }
        toolOrderCatalogs {
          id
          similarToolCatalog {
            id
          }
          quantity
          requesterComments
          toolOrderId
          toolCatalogId
          nonCatalogDescription
          nonCatalogReferenceUrl
          nonCatalogUomId
          toolCatalog {
            id
            bscnPartNumber
            name
            inventoryType
            toolCategoryId
            uomId
            toolCatalogImageUrl
            toolCategory {
              id
              name
            }
          }
        }
        recipientId
        recipientEmployee {
          id
          firstName
          lastName
          middleName
          email
          lobEmployeeId
          userId
          projectId
          user {
            id
            bun
          }
          imageUrl
          persona
        }
        orderPlacedFor
        orderPlacedForUser {
          id
          firstName
          lastName
          employee {
            id
            imageUrl
          }
          employeeImageUrl
          roles {
            id
            name
          }
        }
      }
    }
  }
`;

export const GET_TOOL_CATALOG_COUNT = gql`
  query GetToolCatalogCount($searchInput: SearchInput) {
    toolCatalogsCountForSearch(searchInput: $searchInput)
  }
`;

export const GET_TOOL_ORDER_BY_ID = gql`
  ${CORE_USER_FIELDS}
  query ToolOrderById($toolOrderByIdId: ID!) {
    toolOrderById(id: $toolOrderByIdId) {
      id
      orderNumber
      requiredStartDate
      status
      orderDate
      toolRoomId
      #toolRoom { # uncomment this if you really need it
      #  id
      #  barCode
      #  description
      #}
      toolOrderCatalogs {
        id
        quantity
        requesterComments
        nonCatalogDescription
        nonCatalogReferenceUrl
        nonCatalogSimilarToId
        nonCatalogUomId
        toolCatalog {
          id
          inventoryType
          bscnPartNumber
          name
          toolCatalogImageUrl
          toolCategory {
            id
            name
          }
        }
      }
      createdByUser {
        ...CoreUserFields
      }
      checkedOutByUser {
        ...CoreUserFields
      }
    }
  }
`;

export const GET_TOOL_ORDER_WITH_AVAILABLE_INVENTORY = gql`
  ${CORE_TOOL_ORDER_FIELDS}
  ${CORE_USER_FIELDS}
  query ToolOrderById($toolOrderByIdId: ID!) {
    toolOrderById(id: $toolOrderByIdId) {
      ...ToolOrderCoreFields
      toolOrderCatalogs {
        id
        alreadyIssuedCount
        toolOrderId
        toolCatalogId
        quantity
        nonCatalogDescription
        nonCatalogReferenceUrl
        nonCatalogSimilarToId
        nonCatalogUomId
        dispatcherComments
        requesterComments
        requesterCommentsBy
        requesterCommentsByUser {
          id
          firstName
          lastName
          employee {
            id
            imageUrl
          }
        }
        toolCatalog {
          id
          bscnPartNumber
          name
          inventoryType
          toolCategoryId
          uomId
          isFavorite
          toolCatalogImageUrl
          isLocked
          limitCount
          toolCatalogImageUrl
          toolCategory {
            id
            name
          }
          uom {
            id
            abbreviation
          }
        }
        toolOrderInventories {
          id
          # checkedIn fields are no longer part of tool order inventory
          dispatchQuantity
          toolInventoryId
          status
          toolOrderCatalogId
          dispatcherComments
          dispatcherCommentsBy
          dispatcherCommentsByUser {
            firstName
            lastName
          }
          toolInventory {
            id
            barCode
            toolCatalogId
            description
            isSerialized
            onHandCount
          }
        }
      }
      orderPlacedForUser {
        ...CoreUserFields
        employee {
          persona
        }
      }
      createdByUser {
        ...CoreUserFields
        roles {
          name
          id
        }
      }
      checkedOutByUser {
        ...CoreUserFields
      }
      availableToolInventories {
        toolOrderId
        toolCatalogId
        quantityOnHand
      }
      outOfStockToolOrder {
        orderNumber
        createdBy
        createdDate
        createdByUser {
          ...CoreUserFields
          roles {
            id
            name
          }
        }
        stats {
          id
          consumablesCount
          toolsCount
        }
        toolRoom {
          id
          name
        }
      }
    }
  }
`;
export const GET_TOOL_ORDER_STATS = gql`
  query ToolOrderStats($toolOrderStatsInput: ToolOrderStatsInput!) {
    toolOrderStats(toolOrderStatsInput: $toolOrderStatsInput) {
      result {
        completedCount
        openCount
        outOfStockCount
        cancelledCount
        preparedCount
      }
      error
    }
  }
`;
export const CREATE_ADHOC_TOOL_ORDER = gql`
  ${CORE_TOOL_ORDER_FIELDS}
  mutation CreateAdhocToolOrder($toolOrderInput: ToolOrderInput!) {
    createAdhocToolOrder(toolOrderInput: $toolOrderInput) {
      toolOrder {
        ...ToolOrderCoreFields
      }
      error
    }
  }
`;
export const DELETE_TOOL_ORDER = gql`
  mutation deleteToolOrder($deleteToolOrderInput: DeleteToolOrderInput!) {
    deleteToolOrder(deleteToolOrderInput: $deleteToolOrderInput) {
      id
      errors
    }
  }
`;

export const DISPATCH_TOOL_ORDER = gql`
  mutation DispatchToolOrder($dispatchToolOrderInput: DispatchToolOrderInput!) {
    dispatchToolOrder(dispatchToolOrderInput: $dispatchToolOrderInput) {
      toolOrder {
        id
        orderNumber
        orderDate
        status
        updatedBy
        updatedDate
      }
      error
    }
  }
`;

export const ADVANCE_TOOL_ORDER_STATUS = gql`
  ${CORE_TOOL_ORDER_FIELDS}
  mutation AdvanceToolOrderStatus($advanceToolOrderStatusInput: AdvanceToolOrderStatusInput!) {
    advanceToolOrderStatus(advanceToolOrderStatusInput: $advanceToolOrderStatusInput) {
      toolOrder {
        ...ToolOrderCoreFields
      }
      error
    }
  }
`;
export const CREATE_ADHOC_ORDER = gql`
  ${CORE_TOOL_ORDER_FIELDS}
  mutation CreateAdhocToolOrder($createAdhocOrderInput: CreateAdhocOrderInput!) {
    createAdhocToolOrder(createAdhocOrderInput: $createAdhocOrderInput) {
      toolOrder {
        ...ToolOrderCoreFields
      }
      error
    }
  }
`;

export const GET_OUT_OF_STOCK_TOOL_ORDER_BY_ID = gql`
  query ToolOrderById($toolOrderByIdId: ID!) {
    toolOrderById(id: $toolOrderByIdId) {
      id
      outOfStockToolOrder {
        id
        createdDate
        status
        createdByUser {
          id
          firstName
          lastName
          bun
          employee {
            id
            imageUrl
          }
        }
        stats {
          id
          consumablesCount
          toolsCount
        }
      }
    }
  }
`;

export const CANCEL_TOOL_ORDER = gql`
  mutation CancelToolOrder($cancelToolOrderInput: CancelToolOrderInput!) {
    cancelToolOrder(cancelToolOrderInput: $cancelToolOrderInput) {
      errors
      id
    }
  }
`;

export const TOOL_ORDER_FAMILY_TREE = gql`
  query ToolOrderFamilyTree($toolOrderFamilyTreeId: ID!) {
    toolOrderFamilyTree(id: $toolOrderFamilyTreeId) {
      items {
        id
        orderNumber
        thTransactionNo
        statusHistory {
          status
          createdBy
          toolOrderId
          createdDate
          stats {
            consumablesCount
            toolsCount
            id
          }
          createdByUser {
            firstName
            id
            lastName
            employee {
              firstName
              lastName
              id
              imageUrl
              persona
            }
          }
        }
      }
    }
  }
`;
